







import {
  defineComponent,
  ref,
  onMounted
} from "@vue/composition-api";

export default defineComponent({

  name: "TariffCalculatorDot",
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const elementRef = ref()
    const isFocused = ref(false);
    const handleFocus = () => {
      isFocused.value = true;
    };

    const handleBlur = () => {
      isFocused.value = false;
    };
    onMounted(() => {
      const parentElement = elementRef.value?.parentElement as HTMLElement | null;

      if (parentElement) {
        parentElement.setAttribute('aria-label', props.ariaLabel)
        parentElement.addEventListener('focus', handleFocus);
        parentElement.addEventListener('blur', handleBlur);
      }
    })
    const focusedStyle = {
      boxShadow: "var(--outline-orange)",
      border: "#fff",
      borderWidth: '2px',
      borderStyle: 'solid',
    };

    return {
      elementRef,
      isFocused,focusedStyle
    };
  },
});
